<template lang="pug">
  .tabContent
    ul.tabItemRankList
      v-touch(tag="li", v-for="(rankTab, index) in rankTabs", :key="rankTab.value", :class="{active: currentRankTab === rankTab.value}", @tap="changeRankTab(rankTab.value)")
        button {{rankTab.label}}
</template>

<script>
export default {
  props: ['taskList', 'defaultTaskId'],
  data () {
    const rankTabs = this.taskList.map(task => task.rankTab)
    return {
      rankTabs,
      currentRankTab: rankTabs.find(tab => {
        return tab.value === this.defaultTaskId
      }).value
    }
  },
  methods: {
    changeRankTab (val) {
      this.currentRankTab = val
      this.$bus.$emit('rankTabOnChange', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rankTabs.vue